export const nativeExtensionsList = [
    'photoCapture',
    'groupCall',
    'screenshare',
    'teleconsent',
    'fileTransfer',
    'payments',
    'scheduling',
];
